import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";
import { createSelectors } from "../core/utils/create-selectors";
import { ServiceStore, ServiceStoreActions } from "./types";

const initialState: ServiceStore = {
  selectedMeeting: null,
  selectedService: null,
  selectedMeetingService: null,
  editingMeeting: null,
  editingMeetingService: null,
  editMeetingServiceIsOpen: false,
  editMeetingIsOpen: false,
  editServiceIsOpen: false,
  isChangeMeetingModalOpen: false,
  viewSelected: "attendance",
  assignedServers: [],
  serviceSelected: null,
  referenceMeetingServiceId: undefined,
  historyPanelIsOpen: false
};

const useServiceStoreBase = create(
  persist<ServiceStore & ServiceStoreActions>(
    (set) => ({
      ...initialState,
      selectMeeting: (meeting) => set(() => ({ selectedMeeting: meeting || null })),
      selectService: (service) => set(() => ({ selectedService: service || null })),
      setEditMeetingServiceIsOpen: (isOpen, service) =>
        set((state) => ({
          editMeetingServiceIsOpen: isOpen,
          editingMeetingService: isOpen ? (service !== undefined ? service : state.selectedMeetingService) : null
        })),
      setEditMeetingIsOpen: (isOpen, meeting) =>
        set((state) => ({
          editMeetingIsOpen: isOpen,
          editingMeeting: isOpen ? (meeting !== undefined ? meeting : state.selectedMeeting) : null
        })),
      setEditServiceIsOpen: (isOpen) => set(() => ({ editServiceIsOpen: isOpen })),
      setIsChangeMeetingModalOpen: (isOpen) => set(() => ({ isChangeMeetingModalOpen: isOpen })),
      setViewSelected: (view) => set(() => ({ viewSelected: view })),
      setAssignedServers: (servers) => set(() => ({ assignedServers: servers })),
      setServiceSelected: (serviceId) => set(() => ({ serviceSelected: serviceId })),
      selectMeetingService: (service) => set(() => ({ selectedMeetingService: service || null })),
      setReferenceMeetingServiceId: (serviceId) => set(() => ({ referenceMeetingServiceId: serviceId })),
      setHistoryPanelIsOpen: (isOpen) => set(() => ({ historyPanelIsOpen: isOpen })),
      reset: () => set(() => ({ ...initialState }))
    }),
    { name: "service-store", storage: createJSONStorage(() => localStorage) }
  )
);

export const useServiceStore = createSelectors(useServiceStoreBase);
